var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Portal',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}]},[_c('div',{ref:"containerRef",staticClass:"cover-sheet",attrs:{"data-testid":"cover-sheet"}},[_c('Heading',{staticClass:"cover-sheet__title",attrs:{"level":1}},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }